import {action, classes, Component} from '@codeurs/front'
import m from 'mithril'
import {NavigationItem} from 'types/types'
import Container from 'views/layout/container'
import ContentContainer from 'views/layout/contentcontainer'
import HorizontalScrollNav from 'views/layout/horizontalscrollnav'
import Link from 'views/layout/link'
import AnchorBlock, {AnchorBlockType} from 'views/partials/blocks/anchorblock'
import ImageBlock, {ImageBlockType} from 'views/partials/blocks/imageblock'
import ImageTextBlock, {
	ImageTextBlockType
} from 'views/partials/blocks/imagetextblock'
import PersonBlock, {PersonBlockType} from 'views/partials/blocks/personblock'
import TextBlock, {TextBlockType} from 'views/partials/blocks/textblock'

export type BlockType =
	| {type: 'text'} & TextBlockType
	| {type: 'image_text'} & ImageTextBlockType
	| {type: 'image'} & ImageBlockType
	| {type: 'intro_text'} & TextBlockType
	| {type: 'anchor'} & AnchorBlockType
	| {type: 'person'} & PersonBlockType

export default class Blocks extends Component<{
	blocks: Array<BlockType>
	lists?: any
	channel?: string
}> {
	personcontainers: Array<{type: 'person'} & PersonBlockType>
	constructor(vnode) {
		super(vnode)
		this.personcontainers = []
	}
	view() {
		const {blocks, channel} = this.attrs
		if (!blocks.length) return null

		let navigation: Array<NavigationItem> = blocks
			.filter(
				(block): block is {type: 'anchor'} & AnchorBlockType =>
					block.type == 'anchor'
			)
			.map(block => ({
				id: AnchorBlock.slugify(block.label),
				label: block.label
			}))
		if (channel && channel === 'about') {
			navigation.push({
				id: 'jobs',
				label: 'Jobs'
			})
		}

		return m('.blockscontainer', [
			navigation[0] &&
				m(HorizontalScrollNav,
					{/*style: 'padding-bottom: 40px;', */ mod: 'about'},
					navigation.map(item => this.viewNavItem(item))
				),
			blocks.map((block, i) => this.getBlocks(blocks, block, i))
		])
	}
	viewNavItem(item) {
		return m(Link,
			{
				...action(`#${item.id}`),
				...classes({mod: 'anchors aboutpage'})
			},
			item.label
		)
	}
	getBlocks(blocks: Array<BlockType>, block: BlockType, i: number) {
		if (block.type == 'person') {
			this.personcontainers.push(block)
			if (blocks.length == i + 1 || blocks[i + 1].type != 'person') {
				let persons = m(Container,
					{class: 'mod-persons'},
					this.personcontainers.map((block, i) => this.viewBlock(block, i))
				)
				this.personcontainers = []
				return persons
			} else return null
		}
		return this.viewBlock(block, i)
	}
	viewBlock(block: BlockType, i: Number) {
		const {lists} = this.attrs
		switch (block.type) {
			case 'text':
				return m(TextBlock, block)
			case 'image_text':
				return m(ImageTextBlock, block)
			case 'image':
				return m(ImageBlock, {...block, mod: i == 0 ? 'firstblock' : ''})
			case 'intro_text':
				return m(TextBlock, {...block, mod: 'intro'})
			case 'anchor':
				return m(AnchorBlock, block)
			case 'person':
				return m(PersonBlock, {block, lists})
		}
		return false
	}
}
